<h1>Buttons</h1>
<br>
<div class="flex flex-col gap-8">

  <div class="flex gap-8">
    <elcia-button [label]="'Test'" [size]="'small'" [icon]="'save'"/>
    <elcia-button [label]="'Test'" [icon]="'save'"/>
    <elcia-button [label]="'Test'" [size]="'large'" [icon]="'save'"/>
  </div>

  <div class="flex gap-8">
    <elcia-button [label]="'Test'" [size]="'small'"/>
    <elcia-button [label]="'Test'"/>
    <elcia-button [label]="'Test'" [size]="'large'"/>
  </div>

  <div class="flex gap-8">
    <elcia-button [label]="'Test'" [severity]="'secondary'"/>
    <elcia-button [label]="'Test'" [severity]="'danger'"/>
    <elcia-button [label]="'Test'" [severity]="'success'"/>
    <elcia-button [label]="'Test'" [severity]="'info'"/>
    <elcia-button [label]="'Test'" [severity]="'help'"/>
    <elcia-button [label]="'Test'" [severity]="'warn'"/>
    <elcia-button [label]="'Test'" [severity]="'contrast'"/>
  </div>

  <div class="flex gap-8">
    <elcia-button [label]="'Test'" [disabled]="true"/>
    <elcia-button [label]="'Test'" [isLoading]="true"/>
  </div>


  <div class="flex gap-8">
    <elcia-button [size]="'small'" [icon]="'save'"/>
    <elcia-button [icon]="'save'"/>
    <elcia-button [size]="'large'" [icon]="'save'"/>
  </div>

  <div class="flex gap-8">
    <elcia-button [label]="'Test'" [size]="'small'" [icon]="'save'" [variant]="'text'"/>
    <elcia-button [label]="'Test'" [icon]="'save'" [variant]="'text'"/>
    <elcia-button [label]="'Test'" [size]="'large'" [icon]="'save'" [variant]="'text'"/>
    <elcia-button [variant]="'text'" [size]="'small'" [icon]="'save'"/>
    <elcia-button [variant]="'text'" [icon]="'save'"/>
    <elcia-button [variant]="'text'" [size]="'large'" [icon]="'save'" [severity]="'danger'"/>
  </div>
</div>
